import { Table } from '@factorialco/deprecated-design-system'
import {
  TimesheetPageShiftFragment,
  TimesheetReviewsStatsFragment,
} from 'generated/resources/graphql'
import { Moment } from 'moment'

import { i18nDateToString } from 'modules/core/lib/dates'

import type Store from 'modules/attendance/components/ClockIn/Store'
import { useAttendancePolicies } from 'modules/attendance/lib/attendancePolicies'

import DayRow from './DayRow'
import TableHead from './Head'

interface Props {
  store: Store
  submitHalfDayShift: (shift: TimesheetPageShiftFragment) => Promise<void>
  shiftsHash: Record<string, TimesheetPageShiftFragment[]>
  rangeDays: Moment[]
  reviewsStats: TimesheetReviewsStatsFragment | null
}

const DailyTable = ({ store, submitHalfDayShift, shiftsHash, rangeDays, reviewsStats }: Props) => {
  const { data } = useAttendancePolicies()
  const canEditAttendance = !!data?.employee?._policies?.editAttendance?.can

  const days = rangeDays.map((day: Moment) => {
    const calendarDay = store.getDay(day.date())

    if (!calendarDay) return null

    return (
      <DayRow
        key={day.format()}
        date={day}
        store={store}
        calendarDay={calendarDay}
        submitHalfDayShift={submitHalfDayShift}
        shifts={shiftsHash[i18nDateToString(day, 'backend')] ?? []}
        canEditAttendance={canEditAttendance}
      />
    )
  })

  return (
    <Table>
      <TableHead reviewsStats={reviewsStats} employeeId={store.employeeId} />
      <Table.Body>{days}</Table.Body>
    </Table>
  )
}

export default DailyTable
